import { render, staticRenderFns } from "./StoredValuePopupConfiguration.vue?vue&type=template&id=e3bdb154&scoped=true"
import script from "./StoredValuePopupConfiguration.vue?vue&type=script&lang=js"
export * from "./StoredValuePopupConfiguration.vue?vue&type=script&lang=js"
import style0 from "./StoredValuePopupConfiguration.vue?vue&type=style&index=0&id=e3bdb154&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bdb154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e3bdb154')) {
      api.createRecord('e3bdb154', component.options)
    } else {
      api.reload('e3bdb154', component.options)
    }
    module.hot.accept("./StoredValuePopupConfiguration.vue?vue&type=template&id=e3bdb154&scoped=true", function () {
      api.rerender('e3bdb154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/StoredValuePopupConfiguration.vue"
export default component.exports